import * as React from "react";
import { StyleClass } from "source/app/presentation/Shared/Styles/CSS";
import { dreamService } from "../../../../../../../motw_core/Services/DreamService";
import { hashTagsService } from "motw_core/Services/HashTagsService";
import { StyleClassAuto } from "source/app/presentation/Shared/Styles/Auto/StyleClassAuto";
import _ from "lodash";
import Glyphicon from "source/app/presentation/Shared/Glyphicon/Glyphicon";
import { EGlyphicon } from "../../../Shared/Glyphicon/EGlyphicon";
import { throttle } from "lodash-es";
import { ArrayUtils } from "source/app/services/ArrayUtils";
import { Sounds } from "source/app/services/Sound/Sounds";
import Hyperlink from "source/app/presentation/Shared/Link/Hyperlink";
import { State } from "source/app/services/UI/State/State";
import { ESharedComponent } from "source/app/services/UI/State/ESharedComponent";
import { IDreamsState } from "../IDreamsState";

export function GetRenderedWord({
    word,
    isLastWord,
}: {
    word: string;
    isLastWord: boolean;
}) {
    const renderingStrategy = _.find(renderStrategies, (strategy) =>
        strategy.condition(word)
    );

    if (renderingStrategy) {
        return renderingStrategy.render(word, isLastWord);
    }

    const wordToDisplay = isLastWord ? word : `${word} `;
    return <span>{wordToDisplay}</span>;
}

const renderStrategies = {
    dopamine: {
        condition: (word: string) => !!dreamService.GetDopamineValue(word),
        render: (word: string, isLastWord: boolean) => {
            const wordToDisplay = isLastWord ? word : `${word} `;
            const dopamineValue = dreamService.GetDopamineValue(word);
            const color = dopamineValue! >= 0 ? `cyan` : `#eea5ff`;

            return (
                <span className={StyleClassAuto({ color })}>
                    {wordToDisplay}
                </span>
            );
        },
    },
    hashTag: {
        condition: (word: string) => hashTagsService.IsWordHashTag(word),
        render: (word: string, isLastWord: boolean) => {
            const wordToDisplay = isLastWord ? word : `${word} `;
            return (
                <span
                    className={StyleClass(`dreamNameHashTagWord`, {
                        color: `gold`,
                        fontSize: `9px`,
                    })}
                >
                    {wordToDisplay}
                </span>
            );
        },
    },
    promiseDate: {
        condition: (word: string) => dreamService.IsPromiseDate(word),
        render: (word: string, isLastWord: boolean) => {
            const wordToDisplay = word.replace(/\(|\)/g, "");

            return (
                <span
                    className={StyleClass(`dreamNamePromiseDate`, {
                        color: `#8b8b8b`,
                        fontSize: `9px`,
                    })}
                >
                    {wordToDisplay}
                </span>
            );
        },
    },
    promiseAbbreviation: {
        condition: (word: string) => dreamService.IsPromiseAbbreviation(word),
        render: (word: string, isLastWord: boolean) => {
            const handleMouseEnter = throttle(() => {
                const sound = ArrayUtils.GetRandomElement([
                    Sounds.voice_monks_chant1,
                    Sounds.voice_monks_chant2,
                    Sounds.voice_monks_chant3,
                ]);

                sound.Play({ volume: 0.3, allowConcurrent: true });
            }, 200);

            return (
                <span
                    className={StyleClass(`dreamNamePromiseWord`, {
                        color: `white`,
                        textShadow: "0 0 10px gold",
                        marginRight: `8px`,
                    })}
                    onMouseEnter={handleMouseEnter}
                >
                    <Glyphicon icon={EGlyphicon.move} />
                </span>
            );
        },
    },
    bold: {
        condition: (word: string) => dreamService.IsBoldedWord(word),
        render: (word: string, isLastWord: boolean) => {
            let wordToDisplay = isLastWord ? word : `${word} `;
            wordToDisplay = wordToDisplay.replace(/_/g, "");

            return (
                <span
                    className={StyleClassAuto({
                        fontWeight: `bold`,
                        color: `#daddc0`,
                    })}
                >
                    {wordToDisplay}
                </span>
            );
        },
    },
    projectLink: {
        condition: (word: string) => dreamService.IsProject(word),
        render: (word: string, isLastWord: boolean) => {
            let wordToDisplay = isLastWord ? word : `${word} `;
            wordToDisplay = wordToDisplay.replace(/_/g, "");

            return (
                <span>
                    <span
                        onClick={(event) => {
                            const dreams = State.ReadClass<IDreamsState>(
                                ESharedComponent.Dreams
                            );

                            dreams.setState({ searchText: word });
                            event.preventDefault();
                        }}
                        className={StyleClassAuto({
                            textDecoration: `underline`,
                            textDecorationStyle: `dotted`,
                        })}
                    >
                        {word}
                    </span>
                    {isLastWord ? `` : ` `}
                </span>
            );
        },
    },
};
